import { render } from "./IconSave.vue?vue&type=template&id=06565580"
import script from "./IconSave.vue?vue&type=script&lang=js"
export * from "./IconSave.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__